import {Authentication} from './authentication';
import {AuthenticationAction} from './authentication-action';

const authenticationReducer = (
  state: Authentication,
  action: AuthenticationAction
): Authentication => {
  switch (action.type) {
    case 'INITIALIZE': {
      const {isAuthenticated, user, token, expiresAt} = action.payload;

      return {
        ...state,
        isAuthenticated,
        isInitialized: true,
        user,
        token: isAuthenticated ? token ?? null : null,
        expiresAt: isAuthenticated ? expiresAt ?? null : null,
      };
    }
    case 'LOGIN': {
      const {user, token, expiresAt} = action.payload;
      return {
        ...state,
        isAuthenticated: true,
        isInitialized: true,
        user,
        token,
        expiresAt,
      };
    }
    case 'REFRESH': {
      return {...state, token: action.payload.token, expiresAt: action.payload.expiresAt};
    }
    case 'LOGOUT': {
      return {
        ...state,
        isAuthenticated: false,
        isInitialized: true,
        user: null,
        token: null,
        expiresAt: null,
      };
    }
  }
  return state;
};

export {authenticationReducer};
